import ConfirmationDlg from "../../../../components/ConfirmationDlg";
import React, { useEffect, useState } from "react";
import NormalInput from "../../../../components/form/HorizontalNormalInput";

function ModalChangeProvince({ open, onClose, onSubmit, row }) {
  const [name, setName] = useState("");

  async function onSave() {
    onSubmit({
      name,
    });
    clearFields();
  }

  function clearFields() {
    setName("");
  }

  async function handleClose() {
    clearFields();
    onClose();
  }

  useEffect(() => {
    if (row) {
      setName(row.name);
    } else {
      clearFields();
    }
  }, [row]);

  return (
    <ConfirmationDlg
      open={open}
      btnCancelText="Cancel"
      btnSubmitText={"Submit"}
      onSubmit={onSave}
      onClose={handleClose}
    >
      <h4>Province</h4>
      <div className="my-2">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            m: "auto",
          }}
        >
          <div style={{}}>
            <div style={{ px: 5, py: 4 }}>
              <div style={{ mb: 4 }}>
                <div className={"form-group mb-1"}>
                  <NormalInput
                    required={true}
                    value={name}
                    onchange={(e) => {
                      setName(e.target.value);
                    }}
                    name="name"
                    label={"Name"}
                    className={"form-control border border-theme"}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ConfirmationDlg>
  );
}

export default ModalChangeProvince;
